window.addEventListener('load', function() {

  const archiveFilterBloc = document.querySelectorAll('.archives');
  const archiveFilterItems = document.querySelectorAll('.filter__group__item');

  if (archiveFilterBloc.length) {
    archiveFilterItems.forEach((element) => {
      const archiveFilterOptions = element.querySelectorAll('option');

      if (archiveFilterOptions.length > 1) {
        element.classList.remove('visually-hidden');
      }
    });
  }

});
